var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _class;

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import registry from "./brick-registry";
import Twig from "twig";
import BrickFinder from "./brick-finder";
import AppEvent from "./app-event";
import decopt from "./decopt";
/**
 * @property {HTMLElement} root;
 * @property {DOMStringMap} dataset;
 * @method register
 * @method attr
 * @property {string} tag
 */

var Brick = (_dec = decopt('register', function (target, fn, tag) {
  var twig = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  if (typeof target.tag === "undefined") target.tag = "";
  target.tag = target.tag + tag;
  target.tag = tag;
  target.twig = twig;
  registry.register(target);
}, false), _dec2 = decopt('addClass', function (t, f) {
  for (var _len = arguments.length, classes = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    classes[_key - 2] = arguments[_key];
  }

  return t.options.rootCssClasses = classes;
}), _dec3 = decopt('renderOnConstruct', true), _dec4 = decopt('cleanOnConstruct', true), _dec5 = decopt('initializeSubBricks', true), _dec6 = decopt('listen:listeners', function (target, fn) {
  for (var _len2 = arguments.length, events = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    events[_key2 - 2] = arguments[_key2];
  }

  return events.forEach(function (eventName) {
    return target.options.listeners.push({
      eventName: eventName,
      handlerName: fn
    });
  });
}, function (target) {
  return target.options.listeners = [];
}), _dec7 = decopt('attr', function (target, fn) {
  for (var _len3 = arguments.length, attributes = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
    attributes[_key3 - 2] = arguments[_key3];
  }

  return attributes.forEach(function (attribute) {
    return target.options.observedAttributes.push({
      attribute: attribute,
      handlerName: fn
    });
  });
}, function (target) {
  return target.options.observedAttributes = [];
}), _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = _dec5(_class = _dec6(_class = _dec7(_class = /*#__PURE__*/function () {
  /* --- CONSTRUCTOR ----*/

  /**
   * @param {HTMLElement} root
   * @param {boolean} renderOnConstruct
   */
  function Brick(root) {
    var _this = this;

    var renderOnConstruct = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    _classCallCheck(this, Brick);

    this.root = this.eventSource = root;
    this.root.controller = this;
    this.dataset = this.root.dataset;
    this.constructor.options.rootCssClasses.forEach(function (cssclass) {
      _this.root.classList.add(cssclass);
    });

    var _iterator = _createForOfIteratorHelper(this.constructor.options.listeners),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var event = _step.value;
        var eventName = event.eventName,
            handlerName = event.handlerName;
        this.listen(eventName, this[handlerName].bind(this));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    if (this.constructor.options.observedAttributes.length > 0) {
      new MutationObserver(function (mutationsList) {
        mutationsList.forEach(function (mutation) {
          if (mutation.type === 'attributes') {
            var fn = _this.constructor.options.observedAttributes.find(function (item) {
              return item.attribute === mutation.attributeName;
            }).handlerName;

            if (typeof _this[fn] === "function") {
              _this[fn](mutation.attributeName, _this.root.getAttribute(mutation.attributeName), mutation.oldValue);
            }
          }
        });
      }).observe(this.root, {
        attributes: true,
        childList: false,
        subtree: false,
        attributeOldValue: true,
        attributeFilter: this.constructor.options.observedAttributes.map(function (item) {
          return item.attribute;
        })
      });
    }

    this.initialization = this.initialize();
    if (this.constructor.options.cleanOnConstruct === true) this.clearContent();
    if (this.constructor.options.renderOnConstruct === true && this.constructor.twig && renderOnConstruct) this.render();
  }

  _createClass(Brick, [{
    key: "initialize",
    value: function initialize() {
      this.root.setAttribute('brick-initialized', 'yes');
      return Promise.resolve(this.onInitialize());
    }
    /**
     */

  }, {
    key: "onInitialize",
    value: function onInitialize() {}
    /* --- RENDER ----*/

    /**
     * @param {Object} args
     * @returns {Promise<typeof Brick>}
     */

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
      return this.initialization.then(function () {
        return _this2.beforeRender(args);
      }).then(function () {
        return Promise.resolve(_this2.createViewModel());
      }).then(function (viewModel) {
        return _this2.renderTemplate(viewModel);
      }).then(function (viewModel) {
        return _this2.onRender(viewModel);
      }).then(function () {
        return _this2;
      });
    }
    /**
     * @param {*} args
     * @returns {*}
     */

  }, {
    key: "beforeRender",
    value: function beforeRender(args) {
      return args;
    }
    /**
     * @returns {Object}
     */

  }, {
    key: "createViewModel",
    value: function createViewModel() {
      return {};
    }
    /**
     */

  }, {
    key: "onRender",
    value: function onRender() {}
    /**
     * @param {Object} viewModel
     * @returns {Promise}
     */

  }, {
    key: "renderTemplate",
    value: function renderTemplate(viewModel) {
      var root = this.root;
      var twig = this.constructor.twig;
      var template = document.createElement('template');
      var content = '';
      if (typeof twig === 'function') content = twig(viewModel);
      if (typeof twig === 'string') content = Twig.twig({
        data: twig
      }).render(viewModel, {}, false);
      template.innerHTML = content;
      this.clearContent();
      root.appendChild(template.content.cloneNode(true));
      if (this.constructor.options.initializeSubBricks) return registry.initializeElements(this.root).then(function () {
        return viewModel;
      });
      return Promise.resolve(viewModel);
    }
    /**
     * @param {string|null} selector
     * @param {Function} func
     * @returns {BrickFinder}
     */

  }, {
    key: "$",
    value: function $() {
      var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var func = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return new BrickFinder(selector, this.root, this, func);
    }
    /**
     * @param {string} role
     * @param {Function} func
     * @returns {BrickFinder}
     */

  }, {
    key: "$$",
    value: function $$(role) {
      var func = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return new BrickFinder('[\\(' + role + '\\)], [actor\\:' + role + ']', this.root, this, func);
    }
  }, {
    key: "actor",
    value: function actor(role) {
      this.root.setAttribute('actor:' + role, "");
    }
    /**
     * @param {string | Array<string>} event
     * @param {Function} handler
     */

  }, {
    key: "listen",
    value: function listen(event, handler) {
      AppEvent.listen(event, handler, this.root);
    }
    /**
     * @param {string} event
     * @param {*} data
     * @param {{bubbles:boolean, cancelable: boolean}} options
     */

  }, {
    key: "fire",
    value: function fire(event) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        bubbles: true,
        cancelable: true
      };
      AppEvent.fire(event, data, options, this.eventSource);
    }
  }, {
    key: "message",
    value: function message(event, data, targets) {
      if (targets instanceof BrickFinder) targets = targets.nodes;
      if (!Array.isArray(targets)) targets = [targets];
      targets.forEach(function (target) {
        return AppEvent.fire(event, data, {
          bubbles: false,
          cancelable: true
        }, target);
      });
    }
  }, {
    key: "clearContent",
    value: function clearContent() {
      var node = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.root;

      while (node.firstChild) {
        this.root.removeChild(node.firstChild);
      }
    }
  }, {
    key: "requestAnimationFrame",
    value: function requestAnimationFrame() {
      return new Promise(function (resolve) {
        return window.requestAnimationFrame(resolve);
      });
    }
  }, {
    key: "wait",
    value: function wait(ms) {
      return new Promise(function (resolve) {
        return setTimeout(function () {
          return resolve(ms);
        }, ms);
      });
    }
  }], [{
    key: "register",
    value: function register(tag) {
      var twig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    }
  }, {
    key: "addClass",
    value: function addClass(classes) {}
  }, {
    key: "renderOnConstruct",
    value: function renderOnConstruct(render) {}
  }, {
    key: "cleanOnConstruct",
    value: function cleanOnConstruct(clean) {}
  }, {
    key: "initializeSubBricks",
    value: function initializeSubBricks(init) {}
  }, {
    key: "listen",
    value: function listen(events) {}
  }, {
    key: "attr",
    value: function attr(attributes) {}
    /** @returns {string}*/

  }, {
    key: "selector",
    get: function get() {
      return "[is=\"".concat(this.tag, "\"]");
    }
    /**
     * @param {string} tag
     * @param {boolean} render
     * @param {Object} dataset
     * @returns {Promise<typeof Brick>}
     */

  }, {
    key: "create",
    value: function create() {
      var htmlTag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'div';
      var render = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var dataset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var content = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
      var brick = new this(this.createBrickElement(htmlTag, dataset), false);
      if (render) return brick.render();else return Promise.resolve(brick);
    }
    /**
     * @param {string} htmlTag
     * @param {Object} dataset
     * @returns {HTMLElement}
     */

  }, {
    key: "createBrickElement",
    value: function createBrickElement() {
      var htmlTag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'div';
      var dataset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var content = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var element = document.createElement(htmlTag);
      element.setAttribute('is', this.tag);

      for (var property in dataset) {
        element.dataset[property] = dataset[property];
      }

      element.innerHTML = content;
      return element;
    }
  }]);

  return Brick;
}()) || _class) || _class) || _class) || _class) || _class) || _class) || _class);
export { Brick as default };